import { SearchNavigation } from "../../page/components/ViewPage/Default";
import React from "react";
import { SidePanel } from "../../panels/components/SidePanel";
import { useSearcher } from "./SearcherContext";
import FilterBox from "../../filter/components/FilterBox";
import FacetBox from "../../facet/components/FacetBox";
import ParentObjectNavigation from "../../object/components/ParentObjectNavigation";
import { IC } from "../../iconclass/components/Iconclass";
import { useObjectState } from "../../object/components/ObjectProvider";
import config from "../../../config";

export const SearchSidePanel = props => {
  const panels = [];
  const obj = useObjectState();
  const search = useSearcher();

  if (obj === null) {
    return <SidePanel panels={panels} />;
  }

  if (search.hasSearchFilters()) {
    panels.push({
      key: "search-types",
      title: "Types",
      content: <FacetBox search={search} {...props} />,
      active: true
    });

    if (config.ICONCLASS_ENABLED) {
      panels.push({
        key: "iconclass",
        title: "ICONCLASS",
        content: <IC {...props} />,
        active: true
      });
    }

    if (search.hasSearchFilters()) {
      panels.push({
        key: "search-filters",
        title: "Filters",
        content: <FilterBox search={search} {...props} />,
        active: true
      });
    }
  }

  if (obj._searchPrevious || obj._searchNext) {
    panels.push({
      key: "search-nav",
      title: "Search navigation",
      content: <SearchNavigation {...props} />,
      active: true
    });
  }

  if (obj.hasOwnProperty("PREV") || obj.hasOwnProperty("NEXT")) {
    const tipe = obj.TIPE[0];
    const parentObjectType = tipe
      ? tipe.charAt(0).toUpperCase() + tipe.slice(1)
      : null;
    panels.push({
      key: "parent-nav",
      title: `${parentObjectType || "Parent"} navigation`,
      content: <ParentObjectNavigation obj={obj} {...props} />,
      active: true
    });
  }

  return <SidePanel panels={panels} />;
};
